import { createContext } from 'react'

const UserContext = createContext({
  userName: '',
  setUserName: () => {},
  taskUpdated: [],
  setTaskUpdated: () => {},
})

export default UserContext
